<template>
    <div class="col-md-4 offset-md-4">
        <img class="img-fluid" src="@/assets/9.png">
        <h2 class="display-4 text-center text-light">Sorry, this page does not exist.</h2>
    </div>
</template>